import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, Suspense } from "react";
import { Tooltip, Box, CircularProgress, Fab } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import clsx from "clsx";
import { useFileViewStyles, StyleFileImg, StyleImg } from "./styles";
export function ImagePreview(props) {
    const { file, onRemove, onSelect, imgBackground, selected, children, className, ...rest } = props;
    const classes = useFileViewStyles();
    const onClickRemove = useCallback(e => {
        e.stopPropagation();
        if (onRemove && file)
            onRemove(file);
    }, [file, onRemove]);
    const onClickImage = useCallback(e => {
        e.stopPropagation();
        if (onSelect && file)
            onSelect(file);
    }, [file, onSelect]);
    const filename = decodeURI(file instanceof File ? file.name : file.substring(file.lastIndexOf("/") + 1));
    return (_jsx(Tooltip, { title: filename, children: _jsxs("div", { className: clsx(className, classes.root, classes.preview, {
                [classes.selected]: selected,
                [classes.selectable]: !!onSelect
            }), ...rest, children: [_jsx(Suspense, { fallback: _jsx(Box, { className: classes.img, minWidth: 100, display: "flex", alignItems: "center", justifyContent: "center", onClick: onClickImage, children: _jsx(CircularProgress, {}) }), children: file instanceof File ? (_jsx(StyleFileImg, { className: classes.img, bgcolor: imgBackground, role: "presentation", file: file, onClick: onClickImage })) : (_jsx(StyleImg, { className: classes.img, bgcolor: imgBackground, role: "presentation", src: file, onClick: onClickImage })) }), onRemove && (_jsx(Fab, { size: "small", type: "button", onClick: onClickRemove, "aria-label": "Delete", className: clsx(classes.removeBtn, classes.removeFab), children: _jsx(DeleteIcon, {}) }))] }) }));
}
//# sourceMappingURL=ImagePreview.js.map